// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"bc41293e","899":"5d8e1609"}[chunkId] + ".css";
};